import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorsService } from '../../../../services/indicators/indicators.service';
import { QFilterModel } from '../../../../models/qfilter.model';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { NumberKMPipe } from '../../../../pipes/numberKMPipe';

@Component({
  selector: 'app-customer-division-expense',
  templateUrl: './customer-division-expense.component.html',
  styleUrls: ['./customer-division-expense.component.css']
})

// Pagina 17
export class CustomerDivisionExpenseComponent implements OnInit {
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public translations: any;
  public segmentsInvoiceChart: LoyaltyChart;
  public segmentsInvoiceByDepartementChart: LoyaltyChart;
  public data: QFilterModel;

  constructor (
    private indicatorService: IndicatorsService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private svcAnalytics: AnalyticsService,
    private translate: TranslateService
  ) {

  }

  ngOnInit() {
    this.translate.get([
      'divisionExpense.segmentsInvoiceTitle',
      'divisionExpense.segmentsInvoiceByDepartementTitle',
      'categoryImportance.fatturato_totale',
      'categoryImportance.percentuale_fatturato'
    ]).subscribe((t) => {
      this.translations = {
        segmentsInvoiceTitle: t['divisionExpense.segmentsInvoiceTitle'],
        segmentsInvoiceByDepartementTitle: t['divisionExpense.segmentsInvoiceByDepartementTitle'],
        fatturato_totale: t['categoryImportance.fatturato_totale'],
        percentuale_fatturato: t['categoryImportance.percentuale_fatturato']
      };
      this.initCharts();
    });
  }

  initCharts() {
    this.segmentsInvoiceChart = new LoyaltyChart('bar');
    this.segmentsInvoiceChart.options.xAxis = { type: 'category'};
    this.segmentsInvoiceChart.options.yAxis = { title: {text: this.translations.fatturato_totale} };
    this.segmentsInvoiceChart.options.yAxis.labels = {
      formatter: function () {
        return NumberKMPipe.formatDynamic(this.value, '€')
      }
    };

    this.segmentsInvoiceChart.options.legend = {verticalAlign: 'bottom'};
    this.segmentsInvoiceChart.options.legend.enabled = false;
    this.segmentsInvoiceChart.options.tooltip = {
      formatter: function () {
        return NumberKMPipe.formatDynamic(this.y, '€')
      }
    };

    this.segmentsInvoiceByDepartementChart = new LoyaltyChart('bar');
    this.segmentsInvoiceByDepartementChart.options.yAxis = {title: {text: this.translations.percentuale_fatturato},
      labels: {format: '{value} %'}
    };
    this.segmentsInvoiceByDepartementChart.options.plotOptions = {series: {stacking: 'percent'}};
    this.segmentsInvoiceByDepartementChart.options.legend = {layout: 'vertical', align: 'right', verticalAlign: 'top'};
    this.segmentsInvoiceByDepartementChart.options.tooltip = {
      formatter: function () {
        return NumberKMPipe.formatDynamic(this.y, '€') + ' (' + NumberKMPipe.formatDynamic(this.percentage, '%') + ')';
      }
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueCustomer(data: QFilterModel) {
    this.data = data;

    this.resetChart ();
    this.segmentsInvoiceInit (data);
    this.segmentsInvoiceByDepartementInit (data);

  }

  resetData() {
    this.data = null;
  }

  resetChart () {
    if (this.segmentsInvoiceChart.instance) {
      while (this.segmentsInvoiceChart.instance.series.length > 0) {
        this.segmentsInvoiceChart.instance.series[0].remove(true);
      }
    }
    if (this.segmentsInvoiceByDepartementChart.instance) {
      while (this.segmentsInvoiceByDepartementChart.instance.series.length > 0) {
        this.segmentsInvoiceByDepartementChart.instance.series[0].remove(true);
      }
    }
  }

  segmentsInvoiceInit (data) {

    Observable.zip (
      this.indicatorService.getChart('customers.Q134', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let colors = res.series[2].serie.reverse();
      let series: Array<any> = [];

      let index = serie0.length;
      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i], color: colors[(index - 1) % 8]} );
        index = index - 1;
      }

      this.segmentsInvoiceChart.options.series = [{ name: this.translations.segmentsInvoiceTitle, colorByPoint: true, data: series }];
      this.segmentsInvoiceChart.instance.addSeries(series);

      this.segmentsInvoiceChart.instance.update(this.segmentsInvoiceChart.options);
      this.segmentsInvoiceChart.instance.redraw();

    });
  }

  segmentsInvoiceByDepartementInit (data) {
    Observable.zip (
      this.indicatorService.getChart('customers.Q135', data, false)
    ).subscribe( ([res]) => {
      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let serie2 = res.series[2].serie;
      const xAxis = {
        serie: serie0.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
      };

      let series: Array<any> = [];
      for (let i = 0; i < serie0.length; i++) {
        let elem = series.find(function (el) {
          return el.name === serie1[i];
        });
        if (typeof elem === 'undefined') {
          series.push({name: serie1[i], data: [serie2[i]]});
        } else {
          elem.data.push(serie2[i]);
        }
      }

      this.segmentsInvoiceByDepartementChart.options.xAxis.categories = xAxis.serie;
      this.segmentsInvoiceByDepartementChart.options.legend.itemStyle = {fontWeight: 'normal'};

      for (let i = 0; i < series.length; i++) {

        this.segmentsInvoiceByDepartementChart.instance.addSeries(series[i]);
      }

      this.segmentsInvoiceByDepartementChart.instance.update(this.segmentsInvoiceByDepartementChart.options);
      this.segmentsInvoiceByDepartementChart.instance.redraw();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-division-expense/customer-division-expense.component.ts